<template>
  <div>
    <div v-if="columns && columns.length && items">
      <div>
        <div class="my-2 mb-4 md-min:m-t-6 flex ai-center jc-between">
          <button class="btn btn-info btn-icon m-r-6" @click="$emit('addItem')">
            <span class="ti-plus"></span>
            {{ "add" | setText("Добавить") }}
          </button>
          <excel-upload 
            ref="excelupload"
            :url="`${itemLink}/${id}/planned_lessons/upload`" class="m-y-2" 
            :getList="getList"
            />
        </div>
        <paper-table
          v-if="items.data.length"
          :itemLink="`${itemLink}/${id}/planned_lessons`"
          :data="items.data"
          :card="cardLink"
          :columns="columns"
          :cardLink="cardLink"
          :removeItem="removeItem"

          @changeData="changeData"
          :dataObject="dataObject"
        ></paper-table>
        <div v-else>
          {{ "not_found" | setText("Не найдено (пусто)") }}
        </div>
      </div>      
      <div class="fixed-pagination">
        <div class="responsive-pagination">
          <paginate
            v-if="items.last_page"
            v-show="items.last_page > 1"
            :container-class="'pagination-project'"
            :page-range="3"
            v-model="items.current_page"
            :pageCount="items.last_page"
            :prevText="'‹'"
            :nextText="'›'"
          >
          </paginate>
        </div>
      </div>
    </div>

    <add-item
      @close="$emit('close')"
      v-if="fields && fields.length && setLink && add == true"
      :fieldsFrom="fields"
      :getList="getList"
      :setLink="setLink"
      :cardLink="cardLink"
    />
  </div>
</template>
<script>
import { cardGetList } from "@/plugins/functions";
import PaperTable from "@/components/PaperTable2";
import { mapState } from "vuex";
export default {
  // props: ["itemLink", "pushLink", "add", "id"],
  props: {
    itemLink: String,
    pushLink: String,
    add: Boolean,
    id: {
      default(){
        return null
      }
    },
    params: {
      default: function () {
        return {};
      },
    },
    value: {
      default: function () {
        return [];
      },
    },
  },
  components: {
    "paper-table": PaperTable,
    "add-item": () => import("@/components/Modals/AddItem"),
  },
  data(){
    return { 
      cardLink: "item_lessonplan",
      setLink: "",
      item: null,
      data: null,
      dataObject: {},
      items: {
        last_page: 0,
        current_page: 1,
        total: 0,
        per_page: 15,
        data: [],
      },
      perPages: [15, 20, 50, 100, 500],
      fields: [
        {
          col: "col-12 col-md-4",
          key: "position",
          label: "Номер темы",
          type: "field",
          textType: "number",
        },
        {
          col: "col-12 col-md-8",
          key: "name",
          label: "Название темы",
          type: "field",
          textType: "text",
        },
        {
          col: "col-12 col-md-8",
          key: "homework",
          label: "Домашнее задание",
          type: "field",
          textType: "text",
        },
        {
          label: "Учебник",
          pushLink: this.pushLink,  //"https://stageback.avedu.uz/api/v3/school/subjects/98/classes/39/books",
          key: "classbook",
          type: "select",
          selectKey: "file_name",
          modal: "books",
          params: {}
        },
        {
          col: "col-12 col-md-4",
          key: "classbook_page",
          value: 1,
          label: "Номер страницы",
          type: "field",
          textType: "number",
        },
      ],
      columns: [
        {
          key: "position",
          title: "Номер темы",
          checkbox: false,
          inputSet: true,
          required: true,
        },
        {
          title: "Имя",
          key: "name",
          required: true,
        },
        {
          title: "Учебник",
          key: "classbook",
          typeStyle: "download",
          required: true,
        },
        {
          title: "Страница",
          key: "classbook_page",
          hidden: true,
          required: true,
        },
        {
          title: "Д/З",
          key: "homework",
          hidden: true,
          required: true,
        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    }
  },
  watch:{
    add(){
      this.setLink = `${this.itemLink}/${this.id}/planned_lessons`
    },
    id(){
      this.getList()  
    },
    page(val) {
      if (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.getList();
        }, 100);
      }
    },
    params: {
      handler: function (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.items.current_page = val.page;
        setTimeout(() => {
          this.getList();
        }, 100);
      },
      deep: true,
    },
  },
  async created() {
    this.setLink = `${this.itemLink}/${this.id}/planned_lessons`
    this.getList()
  },
  methods: {
    cardGetList: cardGetList,
    changeData(val) {
      this.items.data = val;
    },
    setPage(event) {
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        let page = event.target.value;
        this.items.current_page = parseInt(page);
      }, 600);
      
    },
    setPerPage(event) {
      this.items.current_page = 1;
      console.log('setPerPage')
      setTimeout(() => {
        this.getList();
      }, 10);
    },
    async getList(loading = true, resetPage = false){
      let params = this.params ? this.params : {};

      params["page"] = this.items.current_page;
      params["per_page"] = this.items.per_page;

      this.loading = true;
      if (loading) {
        this.$loading(true);
      }
      this.data = await this.cardGetList(`${this.itemLink}/${this.id}/planned_lessons`, '', this.params)
      this.items.data = this.data.data
      this.$refs.excelupload.clear()
      if(this.data.meta){
        this.items.total = this.data.meta.total;
        const perPage = this.data.meta.per_page;
        this.items.per_page = perPage;
        this.items.last_page = Math.ceil(this.items.total / perPage);
      }
      if (this.data.data) {
        let data = this.data.data;
        for (let i = 0; i < this.value.length; i++) {
          this.dataObject[this.value[i].id] = this.value[i];
        }
        for (let i = 0; i < data.length; i++) {
          this.dataObject[data[i].id] = data[i];
        }
      }
    },
    removeItem(itemID){
      this.$dialog
        .confirm("Вы точно хотите удалить?", {
          okText: "Удалить",
          cancelText: "Отмена",
        })
        .then(() => {
          this.$loading(true);
          this.$http
            .delete(`${this.itemLink}/${this.id}/planned_lessons/${itemID}`, { _method: "DELETE" })
            .then((response) => {
              this.getList();
            })
            .catch((error) => {
              errorNotify(error, this.$notify);
            })
            .finally(() => {
              setTimeout(() => {
                this.$loading(false);
              }, 400);
            });
        })
        .catch(() => {});
    },
  },
  computed: {
    page() {
      return this.items.current_page;
    },
    ...mapState(["languages", "courses"]),
  },
};
</script>
<style>
</style>
